<template>
	<svg
		id="shapes"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		x="0px"
		y="0px"
		viewBox="0 0 153 153"
		style="enable-background:new 0 0 153 153;"
		xml:space="preserve"
		:style="`--rotation: ${rotation}deg`"
	>
		<span>{{ shape }}</span>
		<g v-if="shape == 'Z'" class="shape-z">
			<rect x="45" y="63" width="27" height="27" :fill="fill" />
			<rect x="81" y="27" width="27" height="27" :fill="fill" />
			<rect x="45" y="99" width="27" height="27" :fill="fill" />
			<rect x="81" y="63" width="27" height="27" :fill="fill" />
		</g>
		<g v-if="shape == 'T'" class="shape-t">
			<rect x="45" y="27" width="27" height="27" :fill="fill" />
			<rect x="45" y="63" width="27" height="27" :fill="fill" />
			<rect x="45" y="99" width="27" height="27" :fill="fill" />
			<rect x="81" y="63" width="27" height="27" :fill="fill" />
		</g>
		<g v-if="shape == '/'" class="shape-slash">
			<rect x="27" y="27" width="27" height="27" :fill="fill" />
			<rect x="99" y="99" width="27" height="27" :fill="fill" />
			<rect x="63" y="63" width="27" height="27" :fill="fill" />
		</g>
		<g v-if="shape == 'S'" class="shape-s">
			<rect x="81" y="63" width="27" height="27" :fill="fill" />
			<rect x="45" y="27" width="27" height="27" :fill="fill" />
			<rect x="81" y="99" width="27" height="27" :fill="fill" />
			<rect x="45" y="63" width="27" height="27" :fill="fill" />
		</g>
		<g v-if="shape == 'L'" class="shape-l">
			<rect x="45" y="27" width="27" height="27" :fill="fill" />
			<rect x="45" y="63" width="27" height="27" :fill="fill" />
			<rect x="45" y="99" width="27" height="27" :fill="fill" />
			<rect x="81" y="99" width="27" height="27" :fill="fill" />
		</g>
		<g v-if="shape == 'J'" class="shape-j">
			<rect x="81" y="27" width="27" height="27" :fill="fill" />
			<rect x="81" y="63" width="27" height="27" :fill="fill" />
			<rect x="45" y="99" width="27" height="27" :fill="fill" />
			<rect x="81" y="99" width="27" height="27" :fill="fill" />
		</g>
		<g v-if="shape == 'I'" class="shape-i">
			<rect x="64" y="9" width="27" height="27" :fill="fill" />
			<rect x="64" y="45" width="27" height="27" :fill="fill" />
			<rect x="64" y="81" width="27" height="27" :fill="fill" />
			<rect x="64" y="117" width="27" height="27" :fill="fill" />
		</g>
		<g v-if="shape == '4'" class="shape-4">
			<rect x="45" y="45" width="27" height="27" :fill="fill" />
			<rect x="81" y="45" width="27" height="27" :fill="fill" />
			<rect x="45" y="81" width="27" height="27" :fill="fill" />
			<rect x="81" y="81" width="27" height="27" :fill="fill" />
		</g>
		<g v-if="shape == '3'" class="shape-3">
			<rect x="63" y="27" width="27" height="27" :fill="fill" />
			<rect x="63" y="63" width="27" height="27" :fill="fill" />
			<rect x="63" y="99" width="27" height="27" :fill="fill" />
		</g>
		<g v-if="shape == '2'" class="shape-2">
			<rect x="45" y="81" width="27" height="27" :fill="fill" />
			<rect x="81" y="81" width="27" height="27" :fill="fill" />
		</g>
		<g v-if="shape == '1'" class="shape-1">
			<rect x="63" y="63" width="27" height="27" :fill="fill" />
		</g>
	</svg>
</template>

<script>
export default {
	props: {
		shape: {
			type: String,
			default: null,
		},
		fill: {
			type: String,
			default: 'black',
		},
		rotation: {
			type: [String, Number, Boolean],
			default: 0,
		},
	},
}
</script>
<style lang="scss" scoped></style>
